(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define(['exports', 'react', 'prop-types'], factory);
    } else if (typeof exports !== "undefined") {
        factory(exports, require('react'), require('prop-types'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.react, global.propTypes);
        global.Lens = mod.exports;
    }
})(this, function (exports, _react, _propTypes) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _react2 = _interopRequireDefault(_react);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var Lens = function Lens(props) {
        var fadeDurationInMs = props.fadeDurationInMs,
            isHovering = props.isHovering,
            style = props.style,
            translateX = props.translateX,
            translateY = props.translateY;

        var translate = 'translate(' + translateX + 'px, ' + translateY + 'px)';
        var computedStyle = {
            position: 'absolute',
            transform: translate,
            WebkitTransform: translate,
            msTransform: translate,
            opacity: isHovering ? 1 : 0,
            transition: 'opacity ' + fadeDurationInMs + 'ms ease-in'
        };
        var defaultStyle = {
            width: 'auto',
            height: 'auto',
            top: 'auto',
            right: 'auto',
            bottom: 'auto',
            left: 'auto',
            display: 'block'
        };

        return _react2.default.createElement('div', { style: Object.assign({}, defaultStyle, style, computedStyle) });
    };

    Lens.propTypes = {
        style: _propTypes2.default.object,
        fadeDurationInMs: _propTypes2.default.number,
        isHovering: _propTypes2.default.bool,
        translateX: _propTypes2.default.number,
        translateY: _propTypes2.default.number,
        userStyle: _propTypes2.default.object
    };

    Lens.defaultProps = {
        isHovering: false,
        fadeDurationInMs: 0,
        translateX: 0,
        translateY: 0
    };

    exports.default = Lens;
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-image-magnify/dist/Lens.js
 ** module id = 149
 ** module chunks = 0
 **/